import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AxisContainerSize, DateFilterContainer, RangeSelectorContainer, StubChart } from "./styled";
import { Axis, ButtonLayer, hasAtrribteLayer, Options, PlayController, Settings } from "./components";

import { DateFilterContext, DateFilterContextProvider } from "./context";

import { getAdditionalPanelVisibility } from "../../ducks/layout/selectors";
import { clearDateFilterConditions, updateDateFilterLayers } from "../../ducks/dateFilter/dateFilter";
import { useKeyboardAxisControl } from "./hooks";
import { usePresentationMode } from "../../hooks/layout/usePresentationMode";
import { useIsShared } from "../../hooks/api/useIsShared";

const LayersSelector = () => {
  const dispatch = useDispatch();
  const { isPresentationMode } = usePresentationMode();
  const isShared = useIsShared();
  const { layers, isVisibleSettings, setSettingVisibility } = useContext(DateFilterContext);

  const withData = hasAtrribteLayer(layers);
  const isEmptyDateFilter = layers.length === 0;

  useKeyboardAxisControl();

  useEffect(() => {
    dispatch(
      updateDateFilterLayers(
        layers
          .filter(item => item.selected)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr.id]: acc[curr.id]?.includes(curr.attribute)
                ? acc[curr.id] ?? []
                : [...(acc[curr.id] ?? []), curr.attribute],
            }),
            {},
          ),
      ),
    );
  }, [layers]);

  useEffect(() => {
    return () => {
      dispatch(clearDateFilterConditions());
    };
  }, []);

  return (
    <>
      {isVisibleSettings ? <Options /> : null}
      <DateFilterContainer
        size={
          withData ? AxisContainerSize.large : isEmptyDateFilter ? AxisContainerSize.small : AxisContainerSize.medium
        }
      >
        <RangeSelectorContainer>
          <PlayController />
          <Axis />
          {!isPresentationMode && !isShared && (
            <Settings
              onClick={() => {
                setSettingVisibility(true);
              }}
            />
          )}
        </RangeSelectorContainer>
        {isEmptyDateFilter && (
          <RangeSelectorContainer>
            <StubChart />
            {!isPresentationMode && <ButtonLayer />}
            <StubChart />
          </RangeSelectorContainer>
        )}
      </DateFilterContainer>
    </>
  );
};

export const BaseDateFilter = () => {
  const visible = useSelector(getAdditionalPanelVisibility);

  return visible ? <LayersSelector /> : null;
};

export const DateFilter = () => (
  <DateFilterContextProvider>
    <BaseDateFilter />
  </DateFilterContextProvider>
);
